import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const AnnouncementModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Se muestra siempre al cargar o recargar el componente
    const timer = setTimeout(() => setIsOpen(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-emerald-950/40 backdrop-blur-md">
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative bg-white rounded-[2rem] shadow-2xl overflow-hidden max-w-[480px] w-full flex flex-col border border-white/20"
          >
            {/* Botón de cerrar flotante con diseño más integrado */}
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 z-10 p-2 bg-white/80 hover:bg-white text-emerald-900 rounded-full backdrop-blur-md transition-all shadow-md active:scale-90"
              title="Cerrar"
            >
              <SafeIcon icon={FiIcons.FiX} className="text-xl" />
            </button>
            
            {/* Contenedor de Imagen con Ratio Optimizado */}
            <div className="w-full relative bg-gray-50 flex items-center justify-center">
              <img
                src="https://media-manager-c.questera.ai/greta-media/dc2481f48b635389e76b59eaad570d8b6a5c1a47f526326d1d2a23f678860d202846a886e3c7fbd3312e80605514346f/images/aW1hZ2UvanBlZw==/01cf12950899bcbd6ef3d56479cb93ea.jpeg"
                alt="Afiliación Keller Williams Capital"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Contenido Informativo */}
            <div className="p-8 text-center bg-white border-t border-gray-100">
              <div className="inline-block px-3 py-1 bg-emerald-50 text-emerald-700 text-[10px] font-black uppercase tracking-widest rounded-full mb-4">
                Anuncio Oficial
              </div>
              <h3 className="text-2xl font-black text-emerald-950 tracking-tight mb-3">
                ¡Expandimos nuestros horizontes!
              </h3>
              <p className="text-sm text-gray-500 mb-8 leading-relaxed font-medium">
                Arboleda Bienes Raíces ahora cuenta con el respaldo internacional de <strong className="text-emerald-800">Keller Williams</strong>. Más tecnología, más alcance y el mismo compromiso de siempre.
              </p>
              
              <button
                onClick={handleClose}
                className="w-full bg-emerald-900 hover:bg-emerald-950 text-white font-black py-4 rounded-2xl transition-all shadow-xl shadow-emerald-900/20 flex items-center justify-center gap-3 group active:scale-[0.98]"
              >
                <span className="text-xs uppercase tracking-[0.2em]">Explorar Propiedades</span>
                <SafeIcon icon={FiIcons.FiArrowRight} className="transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AnnouncementModal;